import React from 'react'

export default function Alert(props) {
  return (
    <div className="contentAlert" style={{height:"50px"}}>
      {props.alert &&<div className='Alertcontent' >
             <div className={`alert alert-${props.alert.type}`} role="alert">
           <strong> {props.alert.type}</strong>:{props.alert.message}
        </div>
    </div>}
    </div>
  )
}
